import { Collapse, Divider, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { ReactNode, useState } from 'react';
import styles from './CollapseBar.module.css';
interface IProps {
  title: ReactNode;
  defaultCollapsed?: boolean;
  children: ReactNode;
}
function CollapseBar({ title, defaultCollapsed, children }: IProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  return (
    <div>
      <div
        className={styles.collapseBar}
        onClick={() => setCollapsed(!collapsed)}
      >
        <Grid container>
          <Grid item xs={10} sx={{ textAlign: 'left', mt: '8px', ml: 0 }}>
            {title}
          </Grid>
          <Grid
            item
            xs={2}
            sx={{ textAlign: 'right', color: '#3593D0', alignSelf: 'end' }}
          >
            {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </Grid>
        </Grid>
      </div>
      <Divider />
      <Collapse in={!collapsed}>{children}</Collapse>
    </div>
  );
}
export default CollapseBar;
